import { Ajax } from '../classes/ajax';
import { requestRepositioning } from '../utils/combinr';
import { getCurrentLanguage } from '../utils/i18n.js';

import parseQueryString from '../utils/parse-query-string';

function parseHotelItems(items) {
    return items.map(item => {
        item.ranges = item.ranges.map(range => {
            if (!range) {
                return range;
            }

            range = range.map(day => {
                day.from = new Date(day.from * 1000);
                day.to = new Date(day.to * 1000);

                day.variations = day.variations.map(variation => {
                    variation.date = new Date(variation.date * 1000);

                    return variation;
                });

                return day;
            });

            return range;
        });

        return item;
    });
}

export function LoadHotelsForVariations() {
    return function(dispatch, getState) {
        dispatch({
            type: 'HOTELS/LOAD',
        });

        const {cart} = getState();
        let productIds = cart.confirmed_package.hotels;
        const confirmedTickets = cart.confirmed_tickets;

        let packageDate;
        if (confirmedTickets !== null) {
            packageDate = confirmedTickets[0].date;
        }

        if (typeof (packageDate) === 'string') {
            packageDate = new Date(packageDate);
        }

        var query = parseQueryString(document.location.search);
        if (
            query.hotelId != null &&
            productIds.indexOf(parseInt(query.hotelId, 10)) > -1
        ) {
            productIds = [query.hotelId];
        }

        requestRepositioning('start');

        const params = {
            id: productIds,
            date: packageDate.getTime(),
            dates: confirmedTickets[0].all_dates,
            min_days: NOJESRESOR_PRODUCT.hotels.min_days,
            max_days: NOJESRESOR_PRODUCT.hotels.max_days,
            persons: confirmedTickets.length,
        };

        return new Ajax(
            'POST',
            `hotels?l=${getCurrentLanguage()}`,
            params,
        ).then((result) => {
            const items = parseHotelItems(result.data.items);

            dispatch({
                type: 'HOTELS/LOAD_FINISHED',
                payload: {
                    items: items,
                },
            });
        });
    };
}

export function ReloadHotels() {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/DESELECT',
        });

        dispatch(LoadHotelsForVariations());
    };
}

export function SelectHotelNights(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_NIGHTS',
            payload: value,
        });
    };
}

export function SelectHotelRange(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_RANGE',
            payload: value,
        });
    };
}

export function SelectHotelRoomType(value) {
    return function(dispatch) {
        dispatch({
            type: 'HOTELS/SELECT_ROOM_TYPE',
            payload: value,
        });
    };
}

export function ConfirmHotel(hotel) {
    return function(dispatch, getState) {
        let {hotels} = getState();

        return dispatch({
            type: 'HOTELS/CONFIRM',
            payload: {
                confirmed_hotel: hotel,
                confirmed_hotel_range: hotel.ranges[hotels.selected_hotel_nights][hotels.selected_hotel_range],
                selected_hotel_range: hotels.selected_hotel_range,
                selected_hotel_nights: hotels.selected_hotel_nights,
                selected_hotel_room_type: hotels.selected_hotel_room_type,
            },
        });
    };
}
